<template>
  <div class="mb-4">
    <div v-if="mainStore.module.status == 'avant_ouverture'">
      <CountdownLaunch v-if="mainStore.module.status == 'avant_ouverture'"
        :date="mainStore.module.date_debut_inscription" :heure="mainStore.module.heure_debut_inscription">
      </CountdownLaunch>
    </div>
    <div v-if="mainStore.module.status == 'apres_fermeture'">
      <h3 class="font-weight-bold">
        <v-icon icon="mdi-calendar-clock" color="primary" size="xs-small"></v-icon> Fermé depuis le {{
          $moment(mainStore.module.date_fin_inscription).format("DD/MM/YYYY") }} à {{
          mainStore.module.heure_fin_inscription }}
      </h3>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import CountdownLaunch from "@/components/Home/Countdown_Launch.vue";
export default {
  components: { CountdownLaunch },
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="scss" scoped></style>